import styled from 'styled-components';

export const SettingsPageContainer = styled.div`
  max-width: 480px;
  margin: auto;
`;
